import {
	HighlightsContainerRequest,
	HighlightsContainerResponse,
} from '@front-app/modules/group/highlights/model';
import { API_V1, API_V2 } from '../api';
import { GroupAccessSettings, GroupAccessCodesRequest, GroupAccessCodesListItem } from './GroupAccessSettingsModel';
import { parseGroup } from './GroupsApi';
import {
	AdminSettings,
	Group,
	GroupWithCommunity,
	VisibilitySettings,
} from './GroupModel';

export function fetchGroupCustomPage(id: string): Promise<HighlightsContainerResponse[] | null> {
	return API_V2.get(`/groups/${id}/custom-page`)
		.then(({ data }) => data as HighlightsContainerResponse[] | null);
}
export function upsertGroupCustomPage(id: string, highlights: HighlightsContainerRequest[]): Promise<HighlightsContainerResponse[]> {
	return API_V2.post(`/groups/${id}/custom-page`, highlights)
		.then(({ data }) => data as HighlightsContainerResponse[]);
}

export function upsertGroupHighlights(id: string, highlights: HighlightsContainerRequest[]): Promise<HighlightsContainerResponse[]> {
	return API_V2.post(`/groups/${id}/customHighlights`, highlights)
		.then(({ data }) => data as HighlightsContainerResponse[]);
}

export function fetchGroupHighlights(id: string): Promise<HighlightsContainerResponse[] | null> {
	return API_V2.get(`/groups/${id}/customHighlights`)
		.then(({ data }) => data as HighlightsContainerResponse[] | null);
}

export function updateGroupAccessSettings(groupAccess: GroupAccessSettings, id: string): Promise<Group> {
	return API_V1.put(`groups/${id}/settings/access`, groupAccess)
		.then(({ data }) => data as GroupWithCommunity)
		.then(parseGroup)
		.then((groupData) => {
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			const { community, ...group } = groupData;
			return group;
		});
}

export function getGroupAccessCodes(id: string): Promise<GroupAccessCodesListItem[]> {
	return API_V2.get(`groups/${id}/access-codes`)
		.then(({ data }) => data as GroupAccessCodesListItem[]);
}

export function addGroupAccessCodes(id: string, accessCodes: GroupAccessCodesRequest): Promise<GroupAccessCodesListItem[]> {
	return API_V2.post(`groups/${id}/access-codes`, accessCodes)
		.then(({ data }) => data as GroupAccessCodesListItem[]);
}

export function updateNotificationSettings(notificationSettings: AdminSettings, id: string): Promise<AdminSettings> {
	return API_V1.put(`groups/${id}/settings/notifications`, notificationSettings)
		.then(({ data }) => data as AdminSettings);
}

export function updateVisibilitySettings(visibilitySettings: VisibilitySettings, id: string): Promise<VisibilitySettings> {
	return API_V1.put(`groups/${id}/settings/visibility`, visibilitySettings)
		.then(({ data }) => data as VisibilitySettings);
}
